import { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import { Modal } from 'react-bootstrap'
import CreateScriptBody from './CreateScriptBody'
import '../../pages/TeamAdmin/TPVScript/CreateTPVScript/multiselectOverride.css'

const modalsRoot = document.getElementById('root-modals') || document.body

const CreateScript = ({
  show,
  setShowModal,
  modalConfig,
}: any) => {
  const [currentScreen, setCurrentScreen] = useState('createScript')


  //to store data of languageIDs,products IDs so that we can compare and seperate added and delete Data for API
  const [dataFromGetscript, setDataFromGetScript] = useState<any>({
    exisitingLanguages: [],
    existingLanguagesMasterId: [],
    existingProducts: [],
    existingQuestions: [],
  })
  const [payload, setPayload] = useState({
    isActive: true,
    tpvType: 'IVR',
    languageIds: [],
    name: '',
    scriptDescription: '',
    timeConditionCheck: true,
    voice: 'Male',
    scriptQuestions: [],
    productIds: [],
    deleteProducts: [],
    deleteScriptLanguages: [],
    deleteScriptQuestions: [],
  })


  const handleModalClose = () => {
    setPayload({
      isActive: true,
      tpvType: 'IVR',
      languageIds: [],
      name: '',
      scriptDescription: '',
      timeConditionCheck: true,
      voice: 'Male',
      scriptQuestions: [],
      productIds: [],
      deleteProducts: [],
      deleteScriptLanguages: [],
      deleteScriptQuestions: [],
    })

    setDataFromGetScript({
      exisitingLanguages: [],
      existingProducts: [],
      existingQuestions: [],
    })

    setShowModal(false)
  }
  useEffect(() => {
    if (show) {
      setSelectedProducts([])
      setSelectedLanguage([])
      setCurrentScreen('createScript')
    }
  }, [show])

  const [selectedLanguage, setSelectedLanguage] = useState<any>([])
  const [selectedProducts, setSelectedProducts] = useState([])

  const EditOrPreviewHeader = modalConfig.mode === 'edit' ? 'Edit' : 'Preview'

  return createPortal(
    <Modal
      id='kt_modal_create_app'
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName='modal-dialog modal-dialog-centered modal-xl '
      show={show}
      backdrop={true}
      className=''
    >
      <div className='modal-header py-7 d-flex justify-content-between'>
        <h2>
          {`${modalConfig.mode === 'create' || modalConfig.mode === 'clone'
            ? 'Create'
            : EditOrPreviewHeader
            }`}{' '}
          Script
        </h2>
        <div
          className='btn btn-sm btn-icon btn-active-color-primary'
          onClick={() => handleModalClose()}
        >
          <span className='svg-icon svg-icon-1'>
            <svg
              width='24'
              height='24'
              viewBox='0 0 24 24'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <rect
                opacity='0.5'
                x='6'
                y='17.3137'
                width='16'
                height='2'
                rx='1'
                transform='rotate(-45 6 17.3137)'
                fill='currentColor'
              ></rect>
              <rect
                x='7.41422'
                y='6'
                width='16'
                height='2'
                rx='1'
                transform='rotate(45 7.41422 6)'
                fill='currentColor'
              ></rect>
            </svg>
          </span>
        </div>
      </div>
      <div className='modal-body min-h-340px my-lg-3 p-lg-0 script-modal-container'>

        <div
          className='stepper stepper-links px-4 d-flex flex-column between'
          id='create_script_stepper'
          data-kt-stepper='true'
        >

          <div
            className={`row ${currentScreen === 'createScript' ? 'current' : 'pending'}`}
            data-kt-stepper-element='content'
          >
            <CreateScriptBody
              payload={payload}
              setPayload={setPayload}
              selectedLanguage={selectedLanguage}
              setSelectedLanguage={setSelectedLanguage}
              selectedProducts={selectedProducts}
              setSelectedProducts={setSelectedProducts}
              dataFromGetScript={dataFromGetscript}
            />
          </div>
        </div>

      </div>
    </Modal>,
    modalsRoot
  )
}
export default CreateScript
